import { useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "LUMID",
      "description": "Next-generation AI infrastructures with state-of-the-art cloud, data and ML systems. AI-native Lakehouse, Evolving AI Agents, and Next-Gen RL Infrastructures.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      },
      "publisher": {
        "@type": "Organization",
        "name": "LUMID",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
        "description": "AI infrastructure solutions provider"
      }
    });

    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-900">
      <Navigation />
      <Hero />
      <Footer />
    </div>
  );
}